import React, { useState } from 'react'
import MainPageWrapper from '../../global/components/MainPageWrapper'
import UsersTable from '../table/UsersTable'
import NewUser from './new-user/NewUser'

export default function UserManagementMain() {
  const [refetchIndex, setRefetchIndex] = useState(0)
  const incrementRefetchIndex = () => {
    setRefetchIndex(refetchIndex + 1)
  }
  return (
    <MainPageWrapper
      titleFields={
        <NewUser
          setRefetchIndex={incrementRefetchIndex}
          refetchIndex={refetchIndex}
        />
      }>
      <UsersTable
        refetchIndex={refetchIndex}
        setRefetchIndex={incrementRefetchIndex}
      />
    </MainPageWrapper>
  )
}
